import SliderMenuLib from './js/SliderMenuLib'
import { debounce, makeId } from '@kissui/helpers/src/utils'
import { dispatchEvent } from '@kissui/helpers/src/assets/js/eventDispatch'
import { customEvent, itemDisplay } from '@kissui/helpers/src/gtmEvents'
import { EVENT_SLIDE_CHANGE, EVENT_SLIDER_READY } from '@kissui/components'

class SliderMenu extends HTMLElement {
    constructor() {
        super()
        this.slot = this.innerHTML
        this.navBarTravelling = true
        this.disableAutoScroll = false
        this.navBarTravelDirection = ''
        this.navBarTravelDistance = 200
        this.randomId = null
        this.sliderMenu = null
        this.boundOnResize = this.onResize.bind(this)
        this.onLoad = this.onLoad.bind(this)
        this.debouncedOnResize = debounce(this.boundOnResize, 250)
    }

    static get observedAttributes() {
        return ['navBarTravelling', 'navBarTravelDirection', 'navBarTravelDistance']
    }

    render() {
        const navigation = this.getAttribute('navigation') === 'true' ? true : ''
        const a11y_slider_previous_button = this.getAttribute('a11y_slider_previous_button') || ''
        const a11y_slider_next_button = this.getAttribute('a11y_slider_next_button') || ''

        this.innerHTML = `
            <div id="pnProductNav-${this.randomId}" class="pn-ProductNavWrapper ${this.randomId}">
                ${
                    navigation &&
                    `<nb-cta id="pnAdvancerLeft-${this.randomId}"
                        class="pn-Advancer pn-AdvancerLeft"
                        variation="navigation"
                        contrast="highlight"
                        size="32"
                        icon_right="24/symbol/chevron-left"
                        label="${a11y_slider_previous_button}"></nb-cta>`
                }
                ${this.slot}
                ${
                    navigation &&
                    `<nb-cta id="pnAdvancerRight-${this.randomId}"
                        class="pn-Advancer pn-AdvancerRight"
                        variation="navigation"
                        contrast="highlight"
                        size="32"
                        icon_right="24/symbol/chevron-right"
                        label="${a11y_slider_next_button}"></nb-cta>`
                }
                <span id="pnIndicator-${this.randomId}"
                    class="pn-ProductNavIndicator">
                </span>
            </div>

            `
        this.loadSwiper()
    }

    connectedCallback() {
        this.randomId = this.getAttribute('testId')
            ? this.getAttribute('testId')
            : `swiperMenu_${makeId(5)}`
        this.navBarTravelling = this.getAttribute('navBarTravelling') || this.navBarTravelling
        this.navBarTravelDirection =
            this.getAttribute('navBarTravelDirection') || this.navBarTravelDirection
        this.navBarTravelDistance =
            this.getAttribute('navBarTravelDistance') || this.navBarTravelDistance
        this.disableAutoScroll = this.getAttribute('disable_auto_scroll') || ''

        this.render()
        window.addEventListener('resize', this.debouncedOnResize)
    }

    loadSwiper() {
        let navBarTravelDirection = this.navBarTravelDirection
        let navBarTravelDistance = this.navBarTravelDistance

        this.sliderMenu = new SliderMenuLib(this.querySelector('.' + this.randomId), {
            id: this.randomId,
            index: this.index,
            navBarTravelDirection: navBarTravelDirection,
            navBarTravelDistance: navBarTravelDistance,
            disableAutoScroll: this.disableAutoScroll
        })

        this.sliderMenu.then(() => {
            this.classList.add('is-show')

            dispatchEvent({
                eventName: EVENT_SLIDER_READY,
                args: { className: this.randomId },
                element: this
            })
        })

        // Updates slider menu to follow semantics, accessibility
        const productNavLinkWrappers = document.querySelectorAll('.pn-ProductNavLinkWrapper')
        productNavLinkWrappers.forEach(div => {
            const li = document.createElement('li')
            li.classList.add('pn-ProductNavLinkWrapper')
            while (div.firstChild) {
                li.appendChild(div.firstChild)
            }
            div.parentNode.replaceChild(li, div)
        })
    }

    handleClick() {
        dispatchEvent({ eventName: EVENT_SLIDE_CHANGE })

        // GTM 'itemDisplay' event
        itemDisplay({ rootElement: ['nb-slider-menu'] })
    }

    onLoad() {
        this.sliderMenu.then(slider => slider.onLoad())
    }

    onResize() {
        this.sliderMenu.then(slider => slider.onResize())
    }

    onNavigationClick(e) {
        let name = ''

        if (
            e.target &&
            e.target.closest('.link') &&
            e.target.closest('.link').getAttribute('tracking_label')
        ) {
            name = e.target.closest('.link').getAttribute('tracking_label')
        }

        customEvent({ eventAction: 'PLP Content Tab', eventLabel: name })
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedOnResize)
        this.sliderMenu.then(slider => slider.kill())
    }
}

customElements.get('nb-slider-menu') || customElements.define('nb-slider-menu', SliderMenu)

export default SliderMenu
